<template>
    <section>
        <h4>Hardware details</h4>
        <p>Will you be using your SIM card with a new or existing device?</p>
        <div class="selector-cards">
            <selector-card
                title="New Device"
                label="I received a new device from Afrihost"
                :isSelected="hardware === 'new-device'"
                @select="select('new-device')">
            </selector-card>
            <selector-card
                title="Existing Device"
                label="I will be using my own device"
                :isSelected="hardware === 'old-device'"
                @select="select('old-device')">
            </selector-card>
        </div><!-- end.selector-box -->
        <section-footer
            :buttons="buttons"
            @next="next()"
            @back="back()">
        </section-footer>
    </section>
</template>

<script>
    import SelectorCard from '@/components/SelectorCard'
    import SectionFooter from '@/components/SectionFooter'

    export default {
        components: {
            SelectorCard,
            SectionFooter,
        },
        computed: {
            hardware() {
                return this.$store.getters['hardware'];
            },
            provider() {
                return this.$store.getters['provider'];
            },
            buttons() {
                return [
                    {
                        label: 'Back',
                        event: 'back',
                        class: 'ghost',
                        disabled: false
                    },
                    {
                        label: 'Next',
                        event: 'next',
                        class: '',
                        disabled: !this.hardware
                    }
                ]
            }
        },
        data() {
            return {

            }
        },
        methods: {
            select(hardware) {
                this.$store.commit('updateHardware', hardware);
            },
            next() {
                switch(this.provider) {
                    case 'telkom-lte':
                        this.$router.push({name: `setup-telkom-${this.hardware}`});
                        break;
                    case 'pure-lte':
                        this.$router.push({name: `setup-pure-${this.hardware === 'new-device' ? 'new-device' : 'device-type'}`});
                        break;
                    case 'comsol':
                        this.$store.commit('updateDevice', 'zte');
                        this.$router.push({name: `setup-afrihost-${this.hardware === 'new-device' ? 'new-device' : 'device-zte'}`});
                    break;
                    case 'vodacom-lte':
                        this.$router.push({name: `setup-vodacom-${this.hardware === 'new-device' ? 'new-device' : 'device-type'}`});
                        break;
                }
                // let deviceTypeRoute = this.hardware === 'new-device' ? 'new-device' : 'old-device';
                // let providerRoute = this.provider === 'pure-lte' ? 'setup-pure' : 'setup-telkom';
                // this.$router.push({name: `${providerRoute}-${deviceTypeRoute}`});
            },
            back() {
                this.$router.push({name: 'home'});
            },
        }
    }
</script>
